<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title v-if="location">
            {{ location.name }}
        </template>

        <template v-slot:header v-if="location">
            <div class="row mb-0">
                <div class="col">
                    <span class="text-muted">
                        {{ location.company.name }}
                    </span>
                </div>
            </div>
            <div v-if="!location.is_active" class="row mb-0">
                <div class="col">
                    <span class="text-danger-dark text-bold text-italic">
                        Inactive
                    </span>
                </div>
            </div>
            <!-- Tabs -->
            <div class="nav-tabs-container">
                <div class="nav-tabs-scroll-helper">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link" :class="{active: activeTab == 'main'}" href="#tabLocationContentMain" id="tabLocationLinkMain" data-toggle="tab" role="tab" aria-controls="tabLocationContentMain" :aria-selected="activeTab == 'main'">Main</a>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <slot>
            <div class="tab-content" v-if="location">
                <div class="tab-pane" :class="{'show active': activeTab == 'main'}" id="tabLocationContentMain" role="tabpanel" aria-labelledby="tabLocationLinkMain">
                    <!-- Location Information widget -->
                    <info-widget :collapsible="false">
                        <template v-slot:title>Location Information</template>

                        <template v-slot:headerbutton>
                            <button type="button" class="btn btn-outline-primary" @click.prevent="editLocation">
                                <i class="far fa-pen" aria-hidden="true" title="Edit"></i>
                                Edit
                            </button>
                        </template>

                        <slot>
                            <div class="card-body py-1 mt-1">
                                <div class="mui-textfield">
                                    <span class="textfield">
                                        <template v-if="location.address_1">{{ location.address_1 }} {{ location.address_2 }}<br/></template>
                                        <template v-if="location.city_normalized">{{ location.city_normalized }}, </template>{{ location.state }} {{ location.postal_code }}
                                    </span>
                                    <label>Location Address</label>
                                </div>
                                <div class="mui-textfield">
                                    <span class="textfield">
                                        {{ $filters.formatPhoneNumber(location.phone_number) }}
                                    </span>
                                    <label>Phone</label>
                                </div>
                                <div class="mui-textfield">
                                    <span class="textfield">
                                        {{ location.external_pos_id }}
                                    </span>
                                    <label>POS ID</label>
                                </div>
                            </div>
                        </slot>
                    </info-widget>

                    <info-widget :collapsible="true" :is-expanded="positionsExpanded" @toggle_expand="positionsExpanded = !positionsExpanded">
                        <template v-slot:title>Positions ({{ location.positions?.length || 0 }})</template>

                        <slot>
                            <div v-if="activePositions.length" class="p-1">
                                <table class="table css-table widget-table table-fixed">
                                    <thead>
                                        <tr>
                                            <th class="cw-toggle"></th>
                                            <th>Positions</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="position in activePositions" :key="position.id">
                                        <tr>
                                            <td  class="cw-toggle position-relative">
                                                <a href class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': showPositionDetails[position.id]}" @click.prevent="togglePositionDetails(position.id)">
                                                    <collapse-toggle-button />
                                                </a>
                                            </td>
                                            <td class="truncate-wrapper">
                                                <span>{{ position.terminal_value }}</span>
                                            </td>
                                        </tr>
                                        <tr class="child no-transition" v-if="showPositionDetails[position.id]">
                                            <td colspan="2">
                                                <div class="card card-body item-details">
                                                    # of Active Employees: {{ position.num_employees }}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="info-widget-empty p-2" v-else>
                                This location does not have any positions yet.
                            </div>
                        </slot>
                    </info-widget>
                </div>
            </div>
        </slot>

        <edit-location-modal v-if="location" ref="editLocationModal" :location="location" :client="client" @updated="onUpdate" @close="editLocationModalOpen = false" />
    </sidebar>
</template>

<script>
import Sidebar from '@/components/Sidebar'
import InfoWidget from '@/components/InfoWidget'
import ButtonRow from '@/components/ButtonRow'
import EditLocationModal from './EditLocationModal'

export default {
    props: ['locationId', 'client', 'tab', ],
    components: {Sidebar, InfoWidget, ButtonRow, EditLocationModal},
    computed: {
        activePositions() {
            let ret = []
            if (this.location?.positions) {
                ret = this.location.positions.filter(p => p.is_active)
            }
            return ret
        }
    },
    data() {

        return {
            location: null,
            activeTab: this.tab || 'main',
            editLocationModalOpen: false,
            positionsExpanded: true,
            showPositionDetails: {},
        }
    },
    watch: {
        locationId() {
            this.getLocation()
        }
    },
    mounted() {
        this.getLocation()
    },
    methods: {
        getLocation() {
            this.location = null
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/locations/${this.locationId}`).then(resp => {
                this.location = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        editLocation() {
            this.editLocationModalOpen = true
            this.$refs.editLocationModal.open()
        },
        togglePositionDetails(positionId) {
            this.showPositionDetails[positionId] = !this.showPositionDetails[positionId]
        },
        onUpdate(location) {
            if (location) {
                Object.assign(this.location, location)
            }
            this.$emit('updated')
        }
    },
}
</script>
